export const SET_EXPORTS = 'setExports';
export const CLEAR_EXPORTS = 'clearExports';
export const SET_RESOURCE = 'setResource';
export const CLEAR_RESOURCE = 'clearResource';
export const SET_NAME = 'setName';
export const SET_COLUMNS = 'setColumns';
export const SET_EXPORT_DATA = 'setExportData';
export const CLEAR_EXPORT_DATA = 'clearExportData';
export const SET_CONTEXT = 'setContext';
export const CLEAR_CONTEXT = 'clearContext';
export const SET_LOADING = 'setLoading';
export const REMOVE_EXPORTATION = 'removeExportation';
